export enum NumberFormat {
  WithCurrency = 'withCurrency',
  WithPercent = 'withPercent',
}
